import { useState, useEffect } from "react";
import apinode from "../../services/apinode";
import Navbar from '../../components/navbar/navbar.jsx'
const API_URL = `/aguardando-faturamento/${localStorage.idconta}`;

const STATUS_CONFIG = {
  pending: { label: "Pendente", badge: "#f59e0b", bg: "#fef3c7", icon: "⏳" },
  ready_to_ship: { label: "Pronto p/ Envio", badge: "#10b981", bg: "#d1fae5", icon: "🚀" },
};

function formatDate(dateStr) {
  if (!dateStr) return "—";
  return new Date(dateStr).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
}

function StatusBadge({ situacao }) {
  const cfg = STATUS_CONFIG[situacao] || { label: situacao, badge: "#6b7280", bg: "#f3f4f6", icon: "❓" };
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      background: cfg.bg, color: cfg.badge,
      border: `1.5px solid ${cfg.badge}33`,
      borderRadius: 20, padding: "3px 12px",
      fontSize: ".75rem", fontWeight: 700, letterSpacing: ".5px",
    }}>
      {cfg.icon} {cfg.label}
    </span>
  );
}

function StatCard({ title, value, icon, accent, sub }) {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        background: "#fff",
        borderRadius: 16,
        padding: "20px 22px",
        boxShadow: hov ? "0 8px 30px rgba(0,0,0,.10)" : "0 2px 8px rgba(0,0,0,.05)",
        borderLeft: `4px solid ${accent}`,
        transition: "box-shadow .2s, transform .2s",
        transform: hov ? "translateY(-3px)" : "none",
        flex: 1,
        minWidth: 0,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <p style={{ margin: 0, fontSize: ".68rem", fontWeight: 700, letterSpacing: "1.5px", textTransform: "uppercase", color: "#9ca3af" }}>{title}</p>
          <h2 style={{ margin: "4px 0 2px", fontSize: "2.1rem", fontWeight: 900, color: "#111827" }}>{value}</h2>
          {sub && <p style={{ margin: 0, fontSize: ".72rem", color: "#6b7280" }}>{sub}</p>}
        </div>
        <div style={{
          width: 48, height: 48, borderRadius: 14,
          background: `${accent}18`,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: "1.6rem",
        }}>{icon}</div>
      </div>
    </div>
  );
}

function PedidoRow({ pedido, index }) {
  const [vis, setVis] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVis(true), index * 60);
    return () => clearTimeout(t);
  }, [index]);

  const [hov, setHov] = useState(false);

  return (
    <tr
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        opacity: vis ? 1 : 0,
        transform: vis ? "translateY(0)" : "translateY(10px)",
        transition: "opacity .3s ease, transform .3s ease, background .15s",
        background: hov ? "#f8faff" : "transparent",
      }}
    >
      <td style={td}>
        <a
          href={`https://ziphub.com.br/pedido/editar/${pedido.pedido}`}
          target="_blank"
          rel="noreferrer"
          style={{ fontWeight: 800, color: "#3b82f6", fontSize: ".88rem", textDecoration: "none" }}
          onMouseEnter={e => e.currentTarget.style.textDecoration = "underline"}
          onMouseLeave={e => e.currentTarget.style.textDecoration = "none"}
        >
          #{pedido.pedido} 🔗
        </a>
      </td>
      <td style={td}>
        <div style={{ fontWeight: 700, color: "#111827", fontSize: ".88rem" }}>
          {pedido.cliente.split(" (")[0]}
        </div>
        <div style={{ fontSize: ".72rem", color: "#9ca3af", fontFamily: "monospace", marginTop: 1 }}>
          {pedido.apelido}
        </div>
      </td>
      <td style={{ ...td, color: "#6b7280", fontSize: ".83rem" }}>{formatDate(pedido.data)}</td>
      <td style={td}><StatusBadge situacao={pedido.situacao} /></td>
      <td style={{ ...td, color: "#6b7280", fontSize: ".83rem" }}>{formatDate(pedido.data_liberacao)}</td>
    </tr>
  );
}

const td = { padding: "12px 16px", verticalAlign: "middle", borderBottom: "1px solid #f1f5f9" };
const th = {
  padding: "10px 16px", fontSize: ".68rem", fontWeight: 700,
  letterSpacing: "1.5px", textTransform: "uppercase",
  color: "#9ca3af", background: "#f8fafc",
  borderBottom: "2px solid #e5e7eb", whiteSpace: "nowrap",
};

export default function OrderAguardando() {
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");

  const loadPedidos = () => {
    setLoading(true);
    setError(null);
    apinode.get(API_URL)
      .then(({ data }) => { setPedidos(data); setLoading(false); })
      .catch(() => { setError("Falha ao carregar pedidos."); setLoading(false); });
  };

  useEffect(() => { loadPedidos(); }, []);

  const unique = pedidos.filter(
    (p, i, arr) => arr.findIndex(x => x.pedido === p.pedido && x.apelido === p.apelido) === i
  );

  const totalPending = unique.filter(p => p.situacao === "pending").length;
  const totalReady = unique.filter(p => p.situacao === "ready_to_ship").length;

  const filtered = unique.filter(p => {
    const q = search.toLowerCase();
    const matchSearch = !q || String(p.pedido).includes(q) ||
      p.cliente.toLowerCase().includes(q) || p.apelido.toLowerCase().includes(q);
    return matchSearch && (filterStatus === "all" || p.situacao === filterStatus);
  });

  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800;900&display=swap" rel="stylesheet" />
      <style>{`
        * { box-sizing: border-box; }
        .dash-root {
          display: flex; flex-direction: column;
          height: 100vh; overflow: hidden;
          background: #f0f4f8;
          font-family: 'Plus Jakarta Sans', sans-serif;
        }
        /* ── Topbar ── */
        .dash-topbar {
          flex-shrink: 0;
          background: linear-gradient(110deg, #0f172a 0%, #1e3a5f 100%);
          padding: 0 28px;
          height: 60px;
          display: flex; align-items: center; justify-content: space-between;
          box-shadow: 0 2px 12px rgba(0,0,0,.18);
        }
        .dash-topbar h1 { margin: 0; font-size: 1rem; font-weight: 800; color: #fff; letter-spacing: .3px; }
        .dash-topbar small { color: rgba(255,255,255,.45); font-size: .72rem; }
        /* ── Body ── */
        .dash-body {
          flex: 1; overflow: hidden;
          display: flex; flex-direction: column;
          padding: 20px 24px 16px;
          gap: 16px;
        }
        /* ── Cards row ── */
        .cards-row { display: flex; gap: 14px; flex-shrink: 0; }
        /* ── Toolbar ── */
        .toolbar {
          display: flex; align-items: center; gap: 10px;
          flex-shrink: 0; flex-wrap: wrap;
        }
        .search-input {
          padding: 8px 14px; border-radius: 10px;
          border: 1.5px solid #e2e8f0; outline: none;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: .83rem; width: 280px;
          background: #fff; color: #111827;
          transition: border-color .15s, box-shadow .15s;
        }
        .search-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.12); }
        .filter-pill {
          padding: 7px 16px; border-radius: 20px;
          font-size: .75rem; font-weight: 700;
          cursor: pointer; border: 1.5px solid #e2e8f0;
          background: #fff; color: #6b7280;
          transition: all .15s;
        }
        .filter-pill.active { background: #1e3a5f; color: #fff; border-color: #1e3a5f; }
        .filter-pill:hover:not(.active) { border-color: #3b82f6; color: #3b82f6; }
        .refresh-btn {
          margin-left: auto;
          padding: 7px 18px; border-radius: 10px;
          border: 1.5px solid rgba(255,255,255,.15);
          background: #1e3a5f; color: #fff;
          font-size: .78rem; font-weight: 700;
          cursor: pointer; font-family: 'Plus Jakarta Sans', sans-serif;
          transition: background .15s;
        }
        .refresh-btn:hover { background: #2d5282; }
        /* ── Table card ── */
        .table-card {
          flex: 1; overflow: hidden;
          background: #fff; border-radius: 16px;
          box-shadow: 0 2px 10px rgba(0,0,0,.06);
          display: flex; flex-direction: column;
        }
        .table-scroll { flex: 1; overflow-y: auto; }
        .table-scroll::-webkit-scrollbar { width: 6px; }
        .table-scroll::-webkit-scrollbar-track { background: transparent; }
        .table-scroll::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }
        table { width: 100%; border-collapse: collapse; }
        thead th { position: sticky; top: 0; z-index: 1; }
        /* ── Footer ── */
        .dash-footer {
          flex-shrink: 0;
          text-align: center; color: #9ca3af;
          font-size: .68rem; padding-bottom: 4px;
        }
        /* ── Loading / Empty ── */
        .center-state {
          flex: 1; display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          color: #9ca3af; gap: 10px;
        }
        .spinner {
          width: 36px; height: 36px; border-radius: 50%;
          border: 3px solid #e5e7eb;
          border-top-color: #3b82f6;
          animation: spin .7s linear infinite;
        }
        @keyframes spin { to { transform: rotate(360deg); } }
        .count-badge {
          margin-left: auto;
          font-size: .72rem; color: #9ca3af; white-space: nowrap;
        }
        @media (max-width: 600px) {
          .cards-row { flex-direction: column; }
          .search-input { width: 100%; }
        }
      `}</style>
      <Navbar />

      <div className="dash-root">
        {/* ── Topbar ── */}
        <div>
          <div style={{ padding: "16px 24px 0" }}>
            <h1 style={{ margin: 0, fontSize: "1.1rem", fontWeight: 800, color: "#111827" }}>
              📦 Aguardando Faturamento
            </h1>
            <small style={{ color: "#9ca3af", fontSize: ".75rem" }}>Painel de Pedidos</small>
          </div>
        </div>

        {/* ── Body ── */}
        <div className="dash-body">

          {/* Cards */}
          <div className="cards-row">
            <StatCard title="Total de Pedidos" value={unique.length} icon="📋" accent="#3b82f6" sub={`${unique.length} pedido${unique.length !== 1 ? "s" : ""} únicos`} />
            <StatCard title="Pendentes" value={totalPending} icon="⏳" accent="#f59e0b" sub="Aguardando ação" />
            <StatCard title="Prontos p/ Envio" value={totalReady} icon="🚀" accent="#10b981" sub="Liberados para envio" />
          </div>

          {/* Toolbar */}
          <div className="toolbar">
            <input
              className="search-input"
              placeholder="🔍  Buscar pedido, cliente ou canal…"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            {[
              { key: "all", label: "Todos" },
              { key: "pending", label: "⏳ Pendente" },
              { key: "ready_to_ship", label: "🚀 Pronto p/ Envio" },
            ].map(({ key, label }) => (
              <button
                key={key}
                className={`filter-pill ${filterStatus === key ? "active" : ""}`}
                onClick={() => setFilterStatus(key)}
              >{label}</button>
            ))}
            <span className="count-badge">{filtered.length} resultado{filtered.length !== 1 ? "s" : ""}</span>
            <button className="refresh-btn" onClick={loadPedidos}>🔄 Atualizar</button>
          </div>

          {/* Table card */}
          <div className="table-card">
            {loading ? (
              <div className="center-state">
                <div className="spinner" />
                <span>Carregando pedidos…</span>
              </div>
            ) : error ? (
              <div className="center-state" style={{ color: "#ef4444" }}>
                <span style={{ fontSize: "2rem" }}>⚠️</span>
                <span>{error}</span>
              </div>
            ) : (
              <div className="table-scroll">
                <table>
                  <thead>
                    <tr>
                      <th style={th}>Pedido</th>
                      <th style={th}>Cliente / Canal</th>
                      <th style={th}>Data do Pedido</th>
                      <th style={th}>Situação</th>
                      <th style={th}>Data Liberação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.length === 0 ? (
                      <tr>
                        <td colSpan={5} style={{ textAlign: "center", padding: "48px 0", color: "#9ca3af" }}>
                          <div style={{ fontSize: "2rem" }}>🔍</div>
                          <div style={{ marginTop: 8 }}>Nenhum pedido encontrado.</div>
                        </td>
                      </tr>
                    ) : filtered.map((p, i) => (
                      <PedidoRow key={`${p.pedido}-${p.apelido}-${i}`} pedido={p} index={i} />
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="dash-footer">
            Atualizado em {new Date().toLocaleString("pt-BR")} · conta {localStorage.idconta}
          </div>
        </div>
      </div>
    </>
  );
}